module.exports = __webpack_public_path__ + "static/img/R2.0635b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/R2.png
// module id = b2Jd
// module chunks = 0